import { CSSProperties } from 'react'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cl from './prices-block.module.scss'

const styles: CSSProperties = { lineHeight: 'unset' }

export const PricesBlockLoader = () => {
	return (
		<div className={cl.loader}>
			<div>
				<SkeletonLoader height={44} borderRadius={12} width={280} style={styles} />
				<SkeletonLoader height={24} borderRadius={5} width={150} style={styles} />
			</div>
			<SkeletonLoader height={20} borderRadius={5} width={200} style={styles} />
		</div>
	)
}
